import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';

const styles = {
  page: {
    minHeight: '100vh',
    background: '#f0fdfa',
    fontFamily: 'system-ui, sans-serif',
    direction: 'rtl',
    textAlign: 'right',
    padding: '24px 16px',
  },
  wrap: {
    maxWidth: 560,
    margin: '0 auto',
  },
  title: {
    color: '#0f766e',
    fontSize: 36,
    fontWeight: 800,
    marginBottom: 16,
  },
  subtitle: {
    color: '#64748b',
    fontSize: 18,
    marginBottom: 32,
    lineHeight: 1.6,
  },
  section: {
    marginBottom: 24,
  },
  sectionTitle: {
    color: '#0f766e',
    fontSize: 20,
    fontWeight: 700,
    marginBottom: 8,
  },
  sectionText: {
    color: '#475569',
    fontSize: 16,
    lineHeight: 1.7,
  },
  list: {
    marginTop: 8,
    paddingRight: 20,
  },
  listItem: {
    marginBottom: 6,
  },
  termsNote: {
    color: '#475569',
    fontSize: 14,
    lineHeight: 1.6,
    marginTop: 24,
    marginBottom: 8,
  },
  termsLink: {
    color: '#0f766e',
    fontWeight: 600,
    textDecoration: 'none',
  },
  termsRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,
    marginTop: 16,
    marginBottom: 8,
    flexDirection: 'row-reverse',
    justifyContent: 'flex-end',
    cursor: 'pointer',
  },
  checkbox: { marginLeft: 4, marginTop: 4 },
  termsLabel: { fontSize: 14, color: '#475569', textAlign: 'right' },
  buttonDisabled: { opacity: 0.6, cursor: 'not-allowed' },
  buttons: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    marginTop: 40,
  },
  primaryBtn: {
    background: '#0f766e',
    color: '#fff',
    border: 'none',
    padding: 18,
    borderRadius: 12,
    fontSize: 18,
    fontWeight: 600,
    cursor: 'pointer',
    textAlign: 'center',
  },
  secondaryBtn: {
    background: 'transparent',
    color: '#0f766e',
    border: '2px solid #0f766e',
    padding: 16,
    borderRadius: 12,
    fontSize: 16,
    fontWeight: 600,
    cursor: 'pointer',
    textAlign: 'center',
  },
};

export default function Landing() {
  const navigate = useNavigate();
  const [termsAccepted, setTermsAccepted] = useState(false);

  const handleRegister = () => {
    if (!termsAccepted) return;
    navigate('/register');
  };
  const handleLogin = () => {
    if (!termsAccepted) return;
    navigate('/login');
  };

  return (
    <div className="nasati-page" style={styles.page}>
      <div className="nasati-wrap" style={styles.wrap}>
        <h1 className="nasati-landing-title" style={styles.title}>נסעתי</h1>
        <p className="nasati-subtitle" style={styles.subtitle}>
          תיעוד פשוט וברור — מי נהג ברכב ובאיזה זמן. למשפחות ולעסקים קטנים.
        </p>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>איך זה עובד?</h2>
          <div style={styles.sectionText}>
            <ul style={styles.list}>
              <li style={styles.listItem}>בוחרים רכב מרשימת הרכבים במשק הבית</li>
              <li style={styles.listItem}>לוחצים על כפתור גדול וברור „התחל” — מתחילה נסיעה ומתעדת שעה מדויקת</li>
              <li style={styles.listItem}>בסיום הנסיעה לוחצים „עצור” — מתעדים את שעת הסיום</li>
            </ul>
            הנהג הוא תמיד מי שמחזיק את הטלפון — אין צורך לבחור נהג. המערכת שומרת היסטוריית נסיעות מלאה.
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>דוחות ושליפה</h2>
          <div style={styles.sectionText}>
            באתר ניתן להפיק דוחות לפי טווח תאריכים, רכב או נהג — ולשלוף במהירות מי נהג ברכב בתאריך ושעה מסוימים (למשל במקרה של דו״ח תנועה).
          </div>
        </div>

        <div style={styles.section}>
          <h2 style={styles.sectionTitle}>למי זה מתאים?</h2>
          <div style={styles.sectionText}>
            משפחות עם כמה רכבים וכמה נהגים, ועסקים קטנים עם צי רכב — כולם יכולים ליצור „משפחה” במערכת, להזמין את שאר החברים עם קוד, ולנהל את הנסיעות מהאפליקציה בנייד ומהאתר במחשב.
          </div>
        </div>

        <p style={styles.termsNote}>
          <Link to="/terms" style={styles.termsLink}>תנאי שימוש ומדיניות פרטיות</Link>
        </p>
        <label style={styles.termsRow}>
          <input
            type="checkbox"
            checked={termsAccepted}
            onChange={(e) => setTermsAccepted(e.target.checked)}
            style={styles.checkbox}
          />
          <span style={styles.termsLabel}>
            קראתי, הבנתי ומסכימ/ה לתנאים ולמדיניות הפרטיות
          </span>
        </label>

        <div className="nasati-buttons" style={styles.buttons}>
          <button
            type="button"
            className="nasati-primary-btn"
            style={{ ...styles.primaryBtn, ...(!termsAccepted && styles.buttonDisabled) }}
            onClick={handleRegister}
            disabled={!termsAccepted}
          >
            הרשמה
          </button>
          <button
            type="button"
            className="nasati-secondary-btn"
            style={{ ...styles.secondaryBtn, ...(!termsAccepted && styles.buttonDisabled) }}
            onClick={handleLogin}
            disabled={!termsAccepted}
          >
            התחברות
          </button>
        </div>
      </div>
    </div>
  );
}
